export default __webpack_public_path__ + "static/media/lead2.7e9302ea.svg";